import type {TuiCountryIsoCode, TuiLanguage, TuiLanguageCommerce, TuiLanguageCore, TuiLanguageEditor, TuiLanguageKit, TuiLanguageLayout, TuiLanguageTable} from '@taiga-ui/i18n/types';

export const TUI_INDONESIAN_LANGUAGE_ADDON_COMMERCE: TuiLanguageCommerce = {
    cardNumber: ['Nomor', 'Nomor kartu'],
    cardExpiry: ['Kadaluarsa', 'Tanggal kadaluarsa'],
};

export const TUI_INDONESIAN_LANGUAGE_LAYOUT: TuiLanguageLayout = {
    inputSearch: {
        popular: 'Populer',
        history: 'Terakhir',
        placeholder: 'Cari',
        hotkey: 'untuk mencari',
        all: 'Semua',
        empty: 'Tidak ada hasil',
    },
};

export const TUI_INDONESIAN_LANGUAGE_KIT: TuiLanguageKit = {
    cancel: 'Batal',
    done: 'Selesai',
    more: 'Lainnya',
    otherDate: 'Tanggal lain...',
    showAll: 'Tampilkan semua',
    hide: 'Sembunyikan',
    mobileCalendarTexts: [
        'Pilih hari',
        'Pilih periode',
        'Pilih hari',
    ],
    range: ['Dari', 'Sampai'],
    countTexts: ['Lebih', 'Kurang'],
    time: {
        'HH:MM': 'HH:MM',
        'HH:MM AA': 'HH:MM AA',
        'HH:MM:SS': 'HH:MM:SS',
        'HH:MM:SS AA': 'HH:MM:SS AA',
        'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
        'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA',
    },
    dateTexts: {
        DMY: 'hari.bulan.tahun',
        MDY: 'bulan.hari.tahun',
        YMD: 'tahun.bulan.hari',
    },
    digitalInformationUnits: ['Byte', 'Kilobyte', 'Megabyte'],
    passwordTexts: ['Tampilkan kata sandi', 'Sembunyikan kata sandi'],
    copyTexts: ['Salin', 'Tersalin'],
    shortCalendarMonths: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Agu',
        'Sep',
        'Okt',
        'Nov',
        'Des',
    ],
    pagination: ['Halaman sebelumnya', 'Halaman berikutnya'],
    fileTexts: {
        loadingError: 'Kesalahan memuat',
        preview: 'Pratinjau',
        remove: 'Hapus',
    },
    inputFileTexts: {
        defaultLabelSingle: 'atau taruh di sini',
        defaultLabelMultiple: 'atau taruh di sini',
        defaultLinkSingle: 'Pilih file',
        defaultLinkMultiple: 'Pilih file',
        maxSizeRejectionReason: 'File terlalu besar',
        formatRejectionReason: 'Format file tidak valid',
        drop: 'Letakkan file di sini',
        dropMultiple: 'Letakkan file di sini',
    },
    multiSelectTexts: {
        all: 'Pilih semua',
        none: 'Pilih tidak ada',
    },
    confirm: {
        yes: 'Ya',
        no: 'Tidak',
    },
    previewTexts: {
        rotate: 'Putar',
    },
    zoomTexts: {
        zoomOut: 'Perkecil',
        zoomIn: 'Perbesar',
        reset: 'Setel ulang',
    },
    phoneSearch: 'Cari negara atau kode',
};

export const TUI_INDONESIAN_LANGUAGE_ADDON_EDITOR: TuiLanguageEditor = {
    colorSelectorModeNames: ['Warna tunggal', 'Gradien warna'],
    toolbarTools: {
        undo: 'Batalkan',
        redo: 'Ulangi',
        font: 'Font',
        fontStyle: 'Gaya font',
        fontSize: 'Ukuran font',
        bold: 'Tebal',
        italic: 'Miring',
        underline: 'Garis bawah',
        strikeThrough: 'Coret',
        justify: 'Rata',
        justifyLeft: 'Rata kiri',
        justifyCenter: 'Rata tengah',
        justifyRight: 'Rata kanan',
        justifyFull: 'Rata penuh',
        list: 'Daftar',
        indent: 'Tambah indentasi',
        outdent: 'Kurangi indentasi',
        unorderedList: 'Daftar tidak berurut',
        orderedList: 'Daftar berurut',
        quote: 'Kutipan',
        foreColor: 'Warna teks',
        backColor: 'Warna latar',
        hiliteColor: 'Warna sorot',
        clear: 'Bersihkan',
        link: 'Tautan',
        attach: 'Lampirkan file',
        tex: 'Sisipkan TeX',
        code: 'Kode',
        image: 'Sisipkan gambar',
        insertHorizontalRule: 'Sisipkan garis horizontal',
        superscript: 'Superskrip',
        subscript: 'Subskrip',
        insertTable: 'Sisipkan tabel',
        insertGroup: 'Sisipkan grup',
        hiliteGroup: 'Sorot grup',
        removeGroup: 'Hapus grup',
        insertAnchor: 'Sisipkan jangkar',
        mergeCells: 'Gabungkan sel',
        splitCells: 'Pisahkan sel',
        rowsColumnsManaging: 'Kelola baris dan kolom',
        cellColor: 'Warna sel',
        setDetails: 'Atur detail',
        removeDetails: "Hapus detail",
    },
    editorEditLink: {
        urlExample: 'contoh.com',
        anchorExample: 'jangkar',
    },
    editorTableCommands: [
        ['Sisipkan kolom sebelum', 'Sisipkan kolom setelah'],
        ['Sisipkan baris sebelum', 'Sisipkan baris setelah'],
        ['Hapus kolom', 'Hapus baris'],
    ],
    editorCodeOptions: ['Kode dalam teks', 'Blok kode'],
    editorFontOptions: {
        small: 'Kecil',
        large: 'Besar',
        normal: 'Normal',
        title: 'Judul',
        subtitle: 'Subjudul',
    },
};

export const TUI_INDONESIAN_LANGUAGE_ADDON_TABLE: TuiLanguageTable = {
    showHideText: 'Tampilkan/Sembunyikan',
    paginationTexts: {
        pages: 'Halaman',
        linesPerPage: 'Baris per halaman',
        of: 'dari',
    },
};

export const TUI_INDONESIAN_LANGUAGE_CORE: TuiLanguageCore = {
    months: [
        'Januari',
        'Februari',
        'Maret',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Agustus',
        'September',
        'Oktober',
        'November',
        'Desember',
    ],
    close: 'Tutup',
    clear: 'Bersihkan',
    nothingFoundMessage: 'Tidak ada hasil',
    defaultErrorMessage: 'Nilai tidak valid',
    spinTexts: ['Sebelumnya', 'Berikutnya'],
    shortWeekDays: ['Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab', 'Min'],
    countries: {} as Record<TuiCountryIsoCode, string>,
};

export const TUI_INDONESIAN_LANGUAGE: TuiLanguage = {
    name: 'indonesian',
    ...TUI_INDONESIAN_LANGUAGE_CORE,
    ...TUI_INDONESIAN_LANGUAGE_KIT,
    ...TUI_INDONESIAN_LANGUAGE_ADDON_TABLE,
    ...TUI_INDONESIAN_LANGUAGE_ADDON_COMMERCE,
    ...TUI_INDONESIAN_LANGUAGE_ADDON_EDITOR,
    ...TUI_INDONESIAN_LANGUAGE_LAYOUT,
};